import React from "react";
import { IVariation } from "../../../../@types";
import ArrowRight from "../../../../assets/icons/ArrowRight";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import ArrowLeft from "../../../../assets/icons/ArrowLeft";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import { deleteVariationService } from "../../../../backend-services";
import { SubscriptionModal } from "../../../common/Subscription/SubscriptionModal";
import VariantDeletePrompt from "../../../inventory/view/VariantDeletePrompt";

const SelectVariation = ({
  variations,
  handleVariationClick,
  openModalDirect,
  isInventory,
  withoutVariationModal,
  handleDeleteVariation,
  isDeleting,
}: {
  variations: IVariation[];
  handleVariationClick: (variant: IVariation) => void;
  openModalDirect: () => void;
  withoutVariationModal: () => void;
  isInventory?: boolean;
  handleDeleteVariation: (id: string) => Promise<void>;
  isDeleting: boolean;
}) => {
  const [showDeleteVariant, setShowDeleteVariant] = React.useState(false);
  const [variantId, setVariantId] = React.useState("");
  return (
    <div>
      <div className="pb-4 border-b-[1px] flex items-center justify-between border-gray-200 px-5">
        <div className="font-medium text-[14px]">
          <p className="leading-5 text-[#000000]">Product options</p>
          <div className="flex items-center justify-between gap-2 mt-2">
            <p className="leading-5 text-gray-600">
              Select your preferred option
            </p>
          </div>
        </div>
        {isDeleting && (
          <div className=" space-y-4 flex ">
            <div className="inset-y-0 right-6 flex items-center mx-auto w-full justify-center">
              <div className="w-7 h-7 border-4 border-gray-200 border-t-[#044E97] rounded-full animate-spin"></div>
            </div>
          </div>
        )}
      </div>

      <div
        className={`${isInventory ? "max-h-[55vh]" : "max-h-[40vh]"}  overflow-hidden overflow-y-scroll scrollbar`}
      >
        {variations.map((variant) => (
          <div
            key={variant.id}
            className="flex justify-between items-center py-4 hover:bg-slate-300/10 cursor-pointer px-5"
          >
            <div
              onClick={() => handleVariationClick(variant)}
              className="flex-1"
            >
              <h1 className="mb-2">{variant.variantName}</h1>
              <div className="flex gap-4 items-center">
                {variant.types.map((v, i) => (
                  <span
                    key={i}
                    className="text-sm bg-gray-100 p-2 font-medium rounded-md"
                  >
                    {v}
                  </span>
                ))}
              </div>
            </div>
            <div>
              {isInventory ? (
                <button
                  onClick={() => {
                    setShowDeleteVariant(true);
                    setVariantId(variant.id);
                  }}
                >
                  <DeleteIcon />
                </button>
              ) : (
                <ArrowRight color={"black"} size={"17"} />
              )}
            </div>
            {showDeleteVariant && (
              <SubscriptionModal>
                <VariantDeletePrompt
                  id={variant.id}
                  fetchDetail={() => {}}
                  variationId={variant.id}
                  setShowPrompt={setShowDeleteVariant}
                  handleDeleteVariation={() => handleDeleteVariation(variantId)}
                />
              </SubscriptionModal>
            )}
          </div>
        ))}
      </div>

      <div className="py-6 border-b-[1px] border-t-[1px] border-gray-200 px-5 flex justify-between items-center">
        <div className="font-medium text-[14px]">
          <p
            onClick={withoutVariationModal}
            className="cursor-pointer leading-5 text-[#044E97] flex items-center space-x-3"
          >
            <span> Cancel</span>
          </p>
        </div>
        <div className="font-medium text-[14px]">
          <p
            onClick={openModalDirect}
            className="cursor-pointer leading-5 text-[#044E97] flex items-center space-x-3"
          >
            <PlusIcon /> <span> Add another option</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelectVariation;
